var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container pt-4",staticStyle:{"max-width":"45rem"}},[_c('CreatePost'),_c('div',[_c('PlaceholderPost')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }